export default __webpack_public_path__ + "static/media/02.825add56.jpg";